import { apiRequest } from './api';

export interface ArtistListItem {
  id: number;
  slug: string;
  name: string;
  bio_short: string | null;
  city: string | null;
  country: string | null;
  lanes: string | null;
  avatar_url: string | null;
  hero_image_url: string | null;
  is_verified: number;
  likes_count?: number | null;
  releases_count?: number | null;
  features_count?: number | null;
  views_count?: number | null;
  downloads_count?: number | null;
  preview_play_count?: number | null;
}

export interface FetchArtistsResponse {
  artists: ArtistListItem[];
}

export interface FetchArtistsParams {
  q?: string;
}

export interface ArtistReleaseResponse {
  id: number;
  slug: string;
  title: string;
  release_type: string;
  status: 'scheduled' | 'live' | 'sold_out';
  cover_url: string | null;
  price_cents: number | null;
  currency: string;
  limited_total: number | null;
  limited_sold: number;
  pwyw_min_cents: number | null;
  publish_at: string | null;
  preview_track_id?: number | null;
  preview_track_title?: string | null;
  preview_track_duration?: number | null;
  preview_track_likes_count?: number | null;
}

export interface ArtistTopTrackResponse {
  id: number;
  title: string;
  duration_sec: number | null;
  has_preview: number;
  release_id: number;
  release_slug: string;
  release_title: string;
  release_cover: string | null;
  preview_plays: number;
  likes_count?: number | null;
}

export interface ArtistFeaturedTrackResponse {
  id: number;
  title: string;
  duration_sec: number | null;
  has_preview: number;
  price_cents: number | null;
  release_id: number;
  release_slug: string;
  release_title: string;
  release_cover: string | null;
  primary_artist: string;
  likes_count?: number | null;
}

export interface ArtistCollaboratorResponse {
  id: number;
  slug: string;
  name: string;
  avatar_url: string | null;
  track_count: number;
  release_count: number;
}

export interface ArtistDetailResponse extends Omit<ArtistListItem, 'bio_short'> {
  bio_short: string | null;
  bio_long: string | null;
  hero_image_url: string | null;
  presskit_url: string | null;
  contact_email: string | null;
  user?: import('../context/AuthContext').AuthUser | null;
  releases: ArtistReleaseResponse[];
  top_tracks?: ArtistTopTrackResponse[];
  featured_tracks?: ArtistFeaturedTrackResponse[];
  collaborators?: ArtistCollaboratorResponse[];
  likes?: {
    artists: number[];
    tracks: number[];
  };
}

export function fetchArtists(params: FetchArtistsParams = {}) {
  const query = new URLSearchParams();
  if (params.q) {
    query.set('q', params.q);
  }
  const queryString = query.toString();
  const path = `/artists${queryString ? `?${queryString}` : ''}`;
  return apiRequest<FetchArtistsResponse>(path);
}

export function fetchFeaturedArtists() {
  return apiRequest<FetchArtistsResponse>('/artists/featured');
}

export function fetchArtistDetail(slug: string) {
  return apiRequest<ArtistDetailResponse>(`/artists/${slug}`);
}
